module.exports = __webpack_public_path__ + "static/media/iconfinder_14_4698578.f612d3ae.png";